import { CardMedia, CardMediaProps } from '@mui/material'
import { FC } from 'react'

const CardMediaWrapper: FC<CardMediaProps> = ({ ...props }) => <CardMedia {...props} />

export default CardMediaWrapper
